import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createSlots as _createSlots, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/app/ui/assets/svg/edit-button-remark.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_2 from '@/app/ui/assets/svg/x-circle.svg'


const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "grid gap-6 grid-cols-4 w-9/12" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-auto",
  alt: "edit-button-remark"
}, null, -1)
const _hoisted_4 = { class: "text-12px text-red-lp-100 font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-auto",
  alt: "edit-button-remark"
}, null, -1)
const _hoisted_6 = { class: "text-12px text-red-lp-100 font-semibold" }
const _hoisted_7 = {
  class: "w-full flex flex-row bg-yellow-lp-400 col-span-2 rounded-md border-2 border-dashed p-4",
  style: {"border-color":"#f5a324"}
}
const _hoisted_8 = { class: "text-gray-lp-300 text-14px" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "w-2/12" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "w-full h-12 px-4 py-3 bg-gray-lp-1500 rounded-md justify-start items-center gap-3 inline-flex"
}
const _hoisted_14 = { class: "grow shrink basis-0 text-gray-lp-300 text-xs font-normal" }
const _hoisted_15 = {
  key: 0,
  class: "w-1/2 py-3 px-4 flex flex-row items-center rounded-lg",
  style: {"background-color":"#f5f5f5","box-shadow":"0px 1px 4px 0px rgba(26, 20, 33, 0.15)"}
}
const _hoisted_16 = { class: "text-14px font-normal font-montserrat text-gray-lp-300" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_18 = { class: "flex items-end justify-between" }
const _hoisted_19 = { class: "flex gap-x-16" }
const _hoisted_20 = { class: "space-y-2" }
const _hoisted_21 = { class: "font-semibold text-black-lp-300" }
const _hoisted_22 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_23 = { class: "space-y-2" }
const _hoisted_24 = { class: "font-semibold text-black-lp-300" }
const _hoisted_25 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_26 = { class: "space-y-2" }
const _hoisted_27 = { class: "font-semibold text-black-lp-300" }
const _hoisted_28 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_29 = { class: "space-y-2" }
const _hoisted_30 = { class: "font-semibold text-black-lp-300" }
const _hoisted_31 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_32 = { class: "space-y-2" }
const _hoisted_33 = { class: "font-semibold text-black-lp-300" }
const _hoisted_34 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_35 = { class: "flex gap-x-4" }
const _hoisted_36 = { class: "flex-col grid col-gap-2 grid-cols-8 justify-center w-full mt-2" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_38 = { class: "col-span-6 space-y-1" }
const _hoisted_39 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "check-circle"
}, null, -1)
const _hoisted_41 = { class: "text-12px text-black-lp-300" }
const _hoisted_42 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_43 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5",
  alt: "x-circle"
}, null, -1)
const _hoisted_44 = { class: "text-12px text-black-lp-300" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "flex flex-row" }
const _hoisted_47 = { class: "flex flex-col space-y-3" }
const _hoisted_48 = { class: "text-20px font-semibold text-black-lp-200" }
const _hoisted_49 = { class: "space-y-1" }
const _hoisted_50 = { class: "text-12px xxl:text-14px text-gray-lp-600 pr-12" }
const _hoisted_51 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_52 = { class: "text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_53 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-2",
  alt: "check-circle"
}, null, -1)
const _hoisted_54 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_55 = { class: "flex justify-end space-x-3" }
const _hoisted_56 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_EditAddress = _resolveComponent("EditAddress")!
  const _component_ModalBookingReverseJourney = _resolveComponent("ModalBookingReverseJourney")!
  const _component_ModalBookingReverseJourneyV4 = _resolveComponent("ModalBookingReverseJourneyV4")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Print = _resolveComponent("Print")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_DetailLayout, {
        onBack: _ctx.goBack,
        title: _ctx.$t('customStatus.updateStatus'),
        "vertical-separator": false,
        fullPage: ""
      }, {
        data: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(_component_DataWrapper, {
              label: _ctx.isInternal ? _ctx.$t('Nama User') : _ctx.$t('Nama Partner'),
              class: "col-span-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.dataProfile.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataProfile.name = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]), [
              [_vShow, false]
            ]),
            _withDirectives(_createVNode(_component_DataWrapper, {
              label: _ctx.isInternal ? _ctx.$t('Tipe User') : _ctx.$t('Tipe Partner'),
              class: "col-span-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.typeUser,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.typeUser = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]), [
              [_vShow, false]
            ]),
            (_ctx.isInternal)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  class: "col-span-2",
                  label: _ctx.$t('Tipe Konsol')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      onOpenSelect: _ctx.onOpenSelectPartnerType,
                      onCloseSelect: _ctx.onCloseSelectPartnerType,
                      isOpenMenu: _ctx.isOpenPartnerType,
                      value: _ctx.form.partnerType,
                      onChooseSelect: _ctx.onSelectPartnerType,
                      dataSelect: _ctx.partnerAreaTypeList,
                      class: "w-full whitespace-no-wrap my-2 z-10"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isInternal)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  label: _ctx.$t('3LC'),
                  class: "col-span-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearchV2, {
                      onFocus: _cache[3] || (_cache[3] = (search) => _ctx.filterPartners(search, true)),
                      onFilter: _cache[4] || (_cache[4] = (search) => _ctx.filterPartners(search, true)),
                      isLoading: _ctx.isLoadingPartners,
                      options: _ctx.partnersData,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('Masukan 3LC'),
                      modelValue: _ctx.form.partnerName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.partnerName = $event)),
                      onChange: _ctx.onChangePartner,
                      isDisabled: !_ctx.form.partnerType,
                      class: "mt-2"
                    }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onChange", "isDisabled"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: _ctx.$t('Status Terbaru')
            }, {
              default: _withCtx(() => [
                (_ctx.customProcessReasonList.length)
                  ? (_openBlock(), _createBlock(_component_Select, {
                      key: 0,
                      dataSelect: _ctx.customProcessReasonList,
                      onOpenSelect: 
                () =>
                  _ctx.customProcessReasonList.length > 1 ? _ctx.onStatusSelect(true) : {}
              ,
                      onCloseSelect: () => _ctx.onStatusSelect(false),
                      onChooseSelect: _ctx.onSelectStatus,
                      value: _ctx.form.status,
                      isOpenMenu: _ctx.isStatusSelect,
                      isShowDefault: false,
                      heightOptions: "360px",
                      class: "text-12px xxl:text-14px w-full my-1.5"
                    }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            (
              !_ctx.IS_REVERSE_JOURNEY &&
                !_ctx.isHalCd &&
                !_ctx.IS_CNXCD &&
                !_ctx.isRejected &&
                !_ctx.IS_INHUB_OR_OUTHUB
            )
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  label: _ctx.$t('customStatus.remarks'),
                  class: "col-span-2",
                  optional: _ctx.form.status.includes('OCC')
                }, {
                  default: _withCtx(() => [
                    (_ctx.IS_MISBOOKING && _ctx.isInternal)
                      ? (_openBlock(), _createBlock(_component_Select, {
                          key: 0,
                          onOpenSelect: _ctx.onOpenSelectRemarksMisbooking,
                          onCloseSelect: _ctx.onCloseSelectRemarksMisbooking,
                          isOpenMenu: _ctx.isOpenRemarksMisbooking,
                          value: _ctx.form.remarks,
                          onChooseSelect: _ctx.onSelectRemarksMisbooking,
                          dataSelect: _ctx.remarksMisbooking,
                          class: "w-full whitespace-no-wrap my-2 z-10"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"]))
                      : (_ctx.IS_MISBOOKING && _ctx.isConsole)
                        ? (_openBlock(), _createBlock(_component_DataWrapper, {
                            key: 1,
                            class: "col-span-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_lp_input, _mergeProps({
                                modelValue: _ctx.form.remarks,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.remarks = $event)),
                                maxLength: _ctx.disabledBackgroundMisbooking ? 0 : 100
                              }, _ctx.remarksValidation, {
                                disabled: _ctx.disabledBackgroundMisbooking,
                                disableBackground: _ctx.disabledBackgroundMisbooking,
                                isInputBlack: _ctx.disabledBackgroundMisbooking
                              }), null, 16, ["modelValue", "maxLength", "disabled", "disableBackground", "isInputBlack"]),
                              (_ctx.disabledBackgroundMisbooking)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.disabledBackgroundMisbooking = false)),
                                    class: "flex cursor-pointer"
                                  }, [
                                    _hoisted_3,
                                    _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("remarks.change")), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_lp_input, _mergeProps({
                            key: 2,
                            modelValue: _ctx.form.remarks,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.remarks = $event)),
                            placeholder: _ctx.$t('customStatus.remarksPlaceholder'),
                            maxLength: 100
                          }, _ctx.remarksValidation), null, 16, ["modelValue", "placeholder"]))
                  ]),
                  _: 1
                }, 8, ["label", "optional"]))
              : (
              _ctx.isLastStatusMisbooking && _ctx.isUpdatedByInternal && _ctx.isConsole
            )
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 3,
                    label: _ctx.$t('customStatus.remarks'),
                    class: "col-span-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.dataSttToBeUpdate[0]?.reverseDestination.remarks,
                        disabled: "",
                        disableBackground: "",
                        isInputBlack: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : (_ctx.IS_REROUTE && _ctx.isLastStatusHal)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 4,
                      label: "Remarks",
                      class: "col-span-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, _mergeProps({
                          modelValue: _ctx.form.remarks,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.remarks = $event)),
                          maxLength: _ctx.disabledBackgroundHal ? 0 : 100
                        }, _ctx.remarksValidation, {
                          disabled: _ctx.disabledBackgroundHal,
                          disableBackground: _ctx.disabledBackgroundHal,
                          isInputBlack: _ctx.disabledBackgroundHal,
                          "data-testid": 
                _ctx.disabledBackgroundHal
                  ? 'custom-process-reroute-hal-remarks'
                  : 'custom-process-reroute-hal-remarks-input'
              
                        }), null, 16, ["modelValue", "maxLength", "disabled", "disableBackground", "isInputBlack", "data-testid"]),
                        (_ctx.disabledBackgroundHal)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.disabledBackgroundHal = false)),
                              class: "flex cursor-pointer",
                              "data-testid": "custom-process-reroute-hal-change-remarks"
                            }, [
                              _hoisted_5,
                              _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("remarks.change")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_ctx.isHalCd || _ctx.isRejected)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 5,
                        label: _ctx.$t('Alasan'),
                        class: "col-span-2",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            dataSelect: _ctx.reasonList,
                            onOpenSelect: () => _ctx.onOpenReasonSelect(true),
                            onCloseSelect: () => _ctx.onOpenReasonSelect(false),
                            onChooseSelect: _ctx.onSelectReasonType,
                            value: _ctx.form.reasonCode,
                            isOpenMenu: _ctx.reasonSelect,
                            isShowDefault: false,
                            heightOptions: "360px",
                            class: "text-12px xxl:text-14px w-full my-2"
                          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : (!_ctx.IS_CNXCD && !_ctx.IS_INHUB_OR_OUTHUB)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 6,
                          class: "col-span-2 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode("div", _hoisted_7, [
                              _createVNode(_component_Icons, {
                                width: "20",
                                height: "20",
                                name: "warning-circle",
                                class: "mr-2",
                                color: "#f5a324"
                              }),
                              _createVNode("p", _hoisted_8, [
                                (_ctx.IS_RTS || _ctx.IS_RTSHQ)
                                  ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("customStatus.singleSttWarningRtsRtsHq")), 1))
                                  : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("customStatus.singleSttWarningOther", {
                      status: _ctx.form.status.toLowerCase()
                    })), 1))
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
            (_ctx.IS_INHUB_OR_OUTHUB)
              ? (_openBlock(), _createBlock("div", {
                  key: 7,
                  class: ["col-span-2 w-full", `${_ctx.IS_OUTHUB ? 'flex flex-col space-y-6' : ''}`]
                }, [
                  (_ctx.IS_OUTHUB)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 0,
                        label: _ctx.$t('customStatus.hubDestination'),
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectSearchV2, {
                            id: "select-search_hub-destination_update-custom-status",
                            onFilter: _cache[11] || (_cache[11] = (search) => _ctx.filterHubLists(search)),
                            options: _ctx.filterHubList,
                            keyName: "name",
                            keyValue: "hubIndex",
                            placeholder: _ctx.$t('Pilih hub tujuan'),
                            modelValue: _ctx.form.hub,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.hub = $event)),
                            onChange: _ctx.onSelectHub,
                            isDisabled: _ctx.hubList.length <= 1,
                            class: "my-2"
                          }, null, 8, ["options", "placeholder", "modelValue", "onChange", "isDisabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('customStatus.vehicleNumber'),
                    optional: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.form.remarks,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.remarks = $event)),
                        placeholder: _ctx.$t('Masukkan nomor kendaraan')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 2))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              class: "col-span-4",
              label: _ctx.$t(_ctx.scanLabel)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  ref: "inputStt",
                  onEnter: _ctx.onValidateSttNumber,
                  sizeInput: "24px",
                  labelStacked: _ctx.$t('Contoh : 99LP1234567890123/88-22-12345678'),
                  modelValue: _ctx.form.sttNumber,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.sttNumber = $event)),
                  placeholder: _ctx.$t('Masukan No. STT atau Scan Barcode/QR Code'),
                  bold: !!_ctx.form.sttNumber,
                  error: !_ctx.isPaid,
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isPaid = true)),
                  errorCaption: 
                !_ctx.isPaid
                  ? _ctx.$t('customStatus.isPaid', { status: _ctx.form.statusName })
                  : ''
              
                }, null, 8, ["onEnter", "labelStacked", "modelValue", "placeholder", "bold", "error", "errorCaption"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.addSttNumber,
              customClass: "px-12 py-2.5",
              title: _ctx.$t('Tambah'),
              textColor: "white",
              disabled: _ctx.isDisableAddSttNumberOutHub || _ctx.isDisableAddSttNumber
            }, null, 8, ["onClick", "title", "disabled"])
          ]),
          (_ctx.showFilterPOS)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: 
            `grid gap-6 ${
              _ctx.isUpdatedByInternal
                ? 'w-full grid-cols-5'
                : _ctx.IS_MISBOOKING && this.isInternal
                ? 'w-full'
                : 'w-9/12 grid-cols-4'
            }`
          
              }, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.IS_MISBOOKING && _ctx.isInternal ? '' : _ctx.$t('customStatus.pos'),
                  class: "col-span-2"
                }, {
                  default: _withCtx(() => [
                    (_ctx.partnerSttReturn.name)
                      ? (_openBlock(), _createBlock(_component_lp_input, {
                          key: 0,
                          modelValue: _ctx.partnerSttReturn.name,
                          disabled: ""
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock("div", _hoisted_12, [
                          (!_ctx.IS_MISBOOKING)
                            ? (_openBlock(), _createBlock(_component_SelectSearchV2, {
                                key: 0,
                                onFocus: _ctx.filterPartners,
                                onFilter: _ctx.filterPartners,
                                isLoading: _ctx.isLoadingPartners,
                                options: _ctx.partnersData,
                                keyName: "name",
                                keyValue: "id",
                                placeholder: _ctx.$t('customStatus.selectPos'),
                                modelValue: _ctx.form.partnerName,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.partnerName = $event)),
                                onChange: _ctx.onChangePartner,
                                class: "mt-2"
                              }, null, 8, ["onFocus", "onFilter", "isLoading", "options", "placeholder", "modelValue", "onChange"]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode("div", {
                  class: 
              `${
                _ctx.IS_MISBOOKING
                  ? 'flex flex-row items-center gap-x-6 w-full'
                  : 'col-span-2 mt-6'
              }`
            
                }, [
                  _createVNode(_component_DataWrapper, null, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_LpButton, {
                        outline: "",
                        iconV2Fill: "#00875A",
                        iconLeft: "success-status",
                        iconV2: "",
                        iconColor: "green-lp-400",
                        title: _ctx.$t('customStatus.editAddress'),
                        textColor: "red-lp-300",
                        onClick: _ctx.showEditAddress
                      }, null, 8, ["title", "onClick"]), [
                        [_vShow, _ctx.IS_MISBOOKING && _ctx.isInternal && !_ctx.unableProcessMisbooking]
                      ]),
                      _withDirectives(_createVNode(_component_LpButton, {
                        outline: "",
                        iconLeft: "pencil-edit",
                        iconColor: "red-lp-300",
                        iconV2: "",
                        title: _ctx.$t('customStatus.editReceiverAddress'),
                        textColor: "red-lp-300",
                        onClick: _ctx.showEditAddress
                      }, null, 8, ["title", "onClick"]), [
                        [_vShow, _ctx.IS_REROUTE && _ctx.isSubConsole && !_ctx.isUpdatedByInternal]
                      ]),
                      _withDirectives(_createVNode(_component_LpButton, {
                        outline: "",
                        iconLeft: "pencil-edit",
                        iconColor: "red-lp-300",
                        iconV2: true,
                        title: _ctx.$t('customStatus.editReceiverAddress'),
                        textColor: "red-lp-300",
                        disabled: _ctx.isLoadingfetchDetailStt,
                        onClick: _ctx.showEditAddress
                      }, null, 8, ["title", "disabled", "onClick"]), [
                        [_vShow, 
                  _ctx.isAbleToEditAddressReceiver &&
                    _ctx.isLastStatusMisbooking && !_ctx.isUpdatedByInternal &&
                    !(_ctx.IS_MISBOOKING && _ctx.isInternal && !_ctx.unableProcessMisbooking)
                ]
                      ]),
                      _withDirectives(_createVNode(_component_LpButton, {
                        outline: "",
                        iconLeft: "pencil-edit",
                        iconColor: "red-lp-300",
                        iconV2: true,
                        title: _ctx.$t('customStatus.editReceiverAddress'),
                        textColor: "red-lp-300",
                        disabled: _ctx.isLoadingfetchDetailStt,
                        onClick: _ctx.showEditAddress
                      }, null, 8, ["title", "disabled", "onClick"]), [
                        [_vShow, 
                  _ctx.isAbleToEditAddressReceiver &&
                    !_ctx.isLastStatusMisbooking &&
                    !(_ctx.IS_MISBOOKING && _ctx.isInternal && !_ctx.unableProcessMisbooking)
                ]
                      ]),
                      (_ctx.isUpdatedByInternal && _ctx.isLastStatusMisbooking)
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode(_component_Icons, {
                              name: "warning-circle",
                              class: "w-6 text-red-lp-500"
                            }),
                            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("customStatus.backlineAddressUpdated")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.IS_MISBOOKING && _ctx.isInternal && _ctx.unableProcessMisbooking)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode(_component_Icons, {
                          width: "24",
                          height: "24",
                          class: "mr-2",
                          name: "warning-circle",
                          color: "#C64D51"
                        }),
                        _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("customStatus.mustEditAddressMisbooking")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.dataSttToBeUpdate.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_17,
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("customStatus.totalStt")), 1),
                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.formattedTotalStt), 1)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("Total Koli")), 1),
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.formattedTotalPieces), 1)
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("Total Berat Kotor")), 1),
                      _createVNode("div", _hoisted_28, _toDisplayString(_ctx.formattedTotalGrossWeight), 1)
                    ]),
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("Total Berat Dimensi")), 1),
                      _createVNode("div", _hoisted_31, _toDisplayString(_ctx.formattedTotalVolumeWeight), 1)
                    ]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("Total Berat Dikenakan Biaya")), 1),
                      _createVNode("div", _hoisted_34, _toDisplayString(_ctx.formattedTotalChargeableWeight), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _createVNode(_component_LpButton, {
                      outline: "",
                      iconLeft: "delete",
                      title: _ctx.$t('Hapus'),
                      onClick: _ctx.onShowDelete,
                      textColor: "red-lp-300"
                    }, null, 8, ["title", "onClick"]),
                    _createVNode(_component_LpButton, {
                      onClick: _ctx.togglePanel,
                      icon: 
                  _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
                ,
                      title: _ctx.$t('Process'),
                      textColor: "white",
                      disabled: _ctx.isDisableUpdateProcess
                    }, null, 8, ["onClick", "icon", "title", "disabled"]),
                    _createVNode(_component_OverlayPanel, {
                      ref: "op",
                      appendTo: "body",
                      style: {"width":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LpButton, {
                          class: "w-60",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createAndPrint(false))),
                          flat: "",
                          dense: "",
                          iconLeft: "shipment",
                          title: _ctx.$t('customStatus.updateStatus')
                        }, null, 8, ["title"]),
                        _createVNode(_component_LpButton, {
                          class: "w-60",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.createAndPrint(true))),
                          flat: "",
                          dense: "",
                          iconLeft: "printer",
                          title: _ctx.$t('Print PDF')
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ]),
                _createVNode(_component_TableV2, {
                  data: _ctx.dataSttToBeUpdate,
                  columns: _ctx.columns,
                  borderTop: false,
                  hidePagination: true,
                  isPinnedScrollBottom: false,
                  isRightFreeze: "",
                  "total-column-freeze": 0
                }, null, 8, ["data", "columns"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onBack", "title"])
    ]),
    (_ctx.editAddress)
      ? (_openBlock(), _createBlock(_component_EditAddress, {
          key: 0,
          defaultStt: _ctx.formEditAddress,
          posNameForInternal: _ctx.form.cityName,
          posIDForInternal: _ctx.form.originDistrictCode,
          onClose: _ctx.closeEditAddress,
          onOnSubmit: _ctx.assignDataEditAddress
        }, null, 8, ["defaultStt", "posNameForInternal", "posIDForInternal", "onClose", "onOnSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.editAddressReverseJourney)
      ? (_openBlock(), _createBlock(_component_ModalBookingReverseJourney, {
          key: 1,
          defaultStt: _ctx.formEditAddress,
          posNameForInternal: _ctx.partnerPosData.name,
          posIDForInternal: _ctx.partnerPosData.id,
          onClose: _ctx.closeEditAddress,
          rtsOrCnx: _ctx.isRtsOrCnx,
          isRTS: _ctx.isRTS,
          isREROUTE: _ctx.IS_REROUTE,
          onOnSubmit: _ctx.assignDataEditAddress,
          isCustomProcess: ""
        }, null, 8, ["defaultStt", "posNameForInternal", "posIDForInternal", "onClose", "rtsOrCnx", "isRTS", "isREROUTE", "onOnSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalBookingReverseJourneyV4, {
      modelValue: _ctx.editAddressReverseJourneyV4,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.editAddressReverseJourneyV4 = $event)),
      form: _ctx.formEditAddress,
      posIDForInternal: _ctx.partnerPosData.id,
      posNameForInternal: _ctx.partnerPosData.name,
      onOnSubmit: _ctx.assignDataEditAddress,
      onOnChangePartner: _ctx.onChangePartner
    }, null, 8, ["modelValue", "form", "posIDForInternal", "posNameForInternal", "onOnSubmit", "onOnChangePartner"]),
    (_ctx.isPopup)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onSubmit: 
      _ctx.alertPopup?.textCancel ? _ctx.alertPopup?.onDownload : _ctx.alertPopup?.onClick
    ,
          onClose: _ctx.alertPopup?.textCancel ? _ctx.alertPopup?.onClick : () => {},
          title: _ctx.$t(_ctx.alertPopup?.title),
          message: _ctx.$t(_ctx.alertPopup?.message),
          image: _ctx.alertPopup?.image,
          textSuccess: 
      _ctx.alertPopup?.textCancel
        ? !_ctx.alertPopup?.isUsingText
          ? ''
          : _ctx.$t('customStatus.download')
        : _ctx.alertPopup?.textSuccess || _ctx.$t('customStatus.ok')
    ,
          textCancel: _ctx.$t(_ctx.alertPopup?.textCancel || ''),
          class: "px-8",
          customButton: _ctx.alertPopup?.textCancel ? 'px-10' : 'px-6'
        }, _createSlots({ _: 2 }, [
          (!_ctx.alertPopup?.hideCountError)
            ? {
                name: "custom",
                fn: _withCtx(() => [
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode("div", _hoisted_38, [
                      _withDirectives(_createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode("div", _hoisted_41, _toDisplayString(_ctx.countSuccess) + " " + _toDisplayString(_ctx.$t("No. STT Sukses")), 1)
                      ], 512), [
                        [_vShow, _ctx.isPartial]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createVNode("div", _hoisted_44, _toDisplayString(_ctx.countFailed) + " " + _toDisplayString(_ctx.$t("No. STT Gagal")), 1)
                      ], 512), [
                        [_vShow, _ctx.isPartial || _ctx.isFailed]
                      ])
                    ])
                  ])
                ])
              }
            : undefined,
          (_ctx.alertPopup?.customStyleButton)
            ? {
                name: "custom-button",
                fn: _withCtx(() => [
                  _createVNode(_component_lp_button, _mergeProps(_ctx.alertPopup?.customStyleButton, {
                    icon: 
          _ctx.$refs['op-success']?.visible
            ? `chevron-up-white`
            : `chevron-down-white`
        ,
                    onClick: _ctx.togglePanelPrintSuccess
                  }), null, 16, ["icon", "onClick"]),
                  (_ctx.alertPopup?.customStyleButton?.groupOptions.length)
                    ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                        key: 0,
                        ref: "op-success",
                        appendTo: "body",
                        style: {"width":"auto"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alertPopup?.customStyleButton
            .groupOptions, (option, groupIndex) => {
                            return (_openBlock(), _createBlock(_Fragment, {
                              key: option.label
                            }, [
                              _createVNode(_component_LpButton, {
                                onClick: 
              () => {
                option.clickFunction();
                _ctx.$refs['op-success'].hide();
              }
            ,
                                class: "w-auto",
                                flat: "",
                                dense: "",
                                iconLeft: option.icon,
                                title: option.label
                              }, null, 8, ["onClick", "iconLeft", "title"]),
                              (
              groupIndex < _ctx.alertPopup?.customStyleButton.groupOptions.length - 1
            )
                                ? (_openBlock(), _createBlock("hr", _hoisted_45))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }, 512))
                    : _createCommentVNode("", true)
                ])
              }
            : undefined
        ]), 1032, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('customStatus.leavePageTitle'),
      message: _ctx.$t('customStatus.leavePageMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('Keluar'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.handleConfirmationSave,
      title: _ctx.handleConfirmationTitle?.title,
      message: _ctx.handleConfirmationTitle?.message,
      image: "are-you-sure",
      textSuccess: _ctx.$t('Process'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.notification = $event)),
      onClose: _ctx.onCloseNotification,
      data: _ctx.detailSttNotification,
      status: _ctx.isUnpaidNotification ? 'error' : 'success'
    }, null, 8, ["modelValue", "onClose", "data", "status"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showDeleteSttNumber,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.showDeleteSttNumber = $event)),
      persistent: true,
      onReset: _ctx.onCloseDelete
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_46, [
          _createVNode("img", {
            src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
            class: "w-40 mr-12",
            alt: "delete-success"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("Hapus Barang")), 1),
            _createVNode("div", _hoisted_49, [
              _withDirectives(_createVNode("div", _hoisted_50, null, 512), [
                [_directive_sanitize_html, 
              _ctx.$t(
                _ctx.IS_INHUB_OR_OUTHUB
                  ? 'customStatus.deleteInOutHub'
                  : 'customStatus.delete',
                { status: _ctx.form.status }
              )
            ]
              ]),
              _createVNode(_component_LpInput, {
                ref: "deleteStt",
                error: !!_ctx.errorSttNumberDelete,
                errorCaption: _ctx.errorSttNumberDelete,
                onEnter: _ctx.onValidateDeleteSttNumber,
                modelValue: _ctx.sttNumberToDelete,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.sttNumberToDelete = $event))
              }, null, 8, ["error", "errorCaption", "onEnter", "modelValue"])
            ]),
            (_ctx.sttNumberListTrash.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_51, [
                  _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("Terhapus")), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex flex-row",
                      key: item
                    }, [
                      _hoisted_53,
                      _createVNode("div", _hoisted_54, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_55, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onCloseDelete,
            customClass: "px-10 py-2",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('Batal'),
            class: "mt-10"
          }, null, 8, ["onClick", "title"]),
          _createVNode(_component_LpButton, {
            disabled: !_ctx.sttNumberToDelete,
            onClick: _ctx.onDeleteSttNumber,
            customClass: "px-10 py-2",
            textColor: "white",
            title: _ctx.$t('Hapus'),
            class: "mt-10"
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onReset"]),
    (_ctx.roleAccount)
      ? (_openBlock(), _createBlock("img", {
          key: 3,
          id: "logo",
          src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
          class: "hidden",
          alt: "logo"
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_56, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
}